<p-dialog [(visible)]="show" [header]="'Cancel Load ' + (load ? load.propakBOLNumber : '')" showEffect="fade" [modal]="true">
  <form [formGroup]="form" (ngSubmit)="CancelLoad()">
    <div class="p-grid">
      <div class="form-group p-col">
        <label class="required" for="shipshift">Cancel Date/Shift</label>
        <app-worked-shift-selector
          formControlName="canceledShift"
          (dateSelected)="DateSelected($event)"
          (shiftSelected)="ShiftSelected($event)"></app-worked-shift-selector>
        <error-block
          [field]="canceledShift"
          [messages]="{required: 'Cancel Shift is required.'}">
        </error-block>
      </div>
    </div>
    <div class="form-buttons">
      <button pButton
        label="Cancel Load"
        [icon]="saving ? 'pi pi-spin pi-spinner' : 'pi pi-check'"
        [disabled]="!form.valid || saving"
        type="submit"
        [ngClass]="{'p-button-warning ml' : true, 'p-state-disabled' : !form.valid}">
      </button>
    </div>
  </form>
</p-dialog>
